import { DefaultOptionItem } from '@app/pages/clinic/models/common.model';

export const CAT_BREEDS_COLLECTION: DefaultOptionItem[] = [
  { id: 1, name: "Abyssinian" },
  { id: 2, name: "Aegean" },
  { id: 3, name: "American Bobtail" },
  { id: 4, name: "American Curl" },
  { id: 5, name: "American Shorthair" },
  { id: 6, name: "American Wirehair" },
  { id: 7, name: "Aphrodite Giant" },
  { id: 8, name: "Arabian Mau" },
  { id: 9, name: "Asian" },
  { id: 10, name: "Asian Semi-longhair" },
  { id: 11, name: "Australian Mist" },
  { id: 12, name: "Balinese" },
  { id: 13, name: "Bambino" },
  { id: 14, name: "Bengal" },
  { id: 15, name: "Birman" },
  { id: 16, name: "Bombay" },
  { id: 17, name: "Brazilian Shorthair" },
  { id: 18, name: "British Longhair" },
  { id: 19, name: "British Shorthair" },
  { id: 20, name: "Burmese" },
  { id: 21, name: "Burmilla" },
  { id: 22, name: "California Spangled" },
  { id: 23, name: "Chantilly-Tiffany" },
  { id: 24, name: "Chartreux" },
  { id: 25, name: "Chausie" },
  { id: 26, name: "Colorpoint Shorthair" },
  { id: 27, name: "Cornish Rex" },
  { id: 28, name: "Cymric" },
  { id: 29, name: "Cyprus" },
  { id: 30, name: "Devon Rex" },
  { id: 31, name: "Domestic Longhair (Mixed Breed)" },
  { id: 32, name: "Domestic Medium Hair (Mixed Breed)" },
  { id: 33, name: "Domestic Shorthair (Mixed Breed)" },
  { id: 34, name: "Donskoy" },
  { id: 35, name: "Dragon Li" },
  { id: 36, name: "Dwelf" },
  { id: 37, name: "Egyptian Mau" },
  { id: 38, name: "European Shorthair" },
  { id: 39, name: "Exotic Shorthair" },
  { id: 40, name: "Foldex" },
  { id: 41, name: "German Rex" },
  { id: 42, name: "Havana Brown" },
  { id: 43, name: "Highlander" },
  { id: 44, name: "Himalayan" },
  { id: 45, name: "Japanese Bobtail" },
  { id: 46, name: "Javanese" },
  { id: 47, name: "Kanaani" },
  { id: 48, name: "Karelian Bobtail" },
  { id: 49, name: "Khao Manee" },
  { id: 50, name: "Kinkalow" },
  { id: 51, name: "Korat" },
  { id: 52, name: "Korean Bobtail" },
  { id: 53, name: "Korn Ja" },
  { id: 54, name: "Kurilian Bobtail" },
  { id: 55, name: "Lambkin" },
  { id: 56, name: "LaPerm" },
  { id: 57, name: "Lykoi" },
  { id: 58, name: "Maine Coon" },
  { id: 59, name: "Manx" },
  { id: 60, name: "Mekong Bobtail" },
  { id: 61, name: "Minskin" },
  { id: 62, name: "Minuet" },
  { id: 63, name: "Munchkin" },
  { id: 64, name: "Nebelung" },
  { id: 65, name: "Neva Masquerade" },
  { id: 66, name: "Norwegian Forest Cat" },
  { id: 67, name: "Ocicat" },
  { id: 68, name: "Ojos Azules" },
  { id: 69, name: "Oriental Bicolor" },
  { id: 70, name: "Oriental Longhair" },
  { id: 71, name: "Oriental Shorthair" },
  { id: 72, name: "Persian (Modern)" },
  { id: 73, name: "Persian (Traditional)" },
  { id: 74, name: "Peterbald" },
  { id: 75, name: "Pixie-bob" },
  { id: 76, name: "Raas" },
  { id: 77, name: "Ragamuffin" },
  { id: 78, name: "Ragdoll" },
  { id: 79, name: "Russian Blue" },
  { id: 80, name: "Russian White" },
  { id: 81, name: "Sam Sawet" },
  { id: 82, name: "Savannah" },
  { id: 83, name: "Scottish Fold" },
  { id: 84, name: "Selkirk Rex" },
  { id: 85, name: "Serengeti" },
  { id: 86, name: "Siamese" },
  { id: 87, name: "Siberian" },
  { id: 88, name: "Singapura" },
  { id: 89, name: "Snowshoe" },
  { id: 90, name: "Sokoke" },
  { id: 91, name: "Somali" },
  { id: 92, name: "Sphynx" },
  { id: 93, name: "Suphalak" },
  { id: 94, name: "Thai" },
  { id: 95, name: "Thai Lilac" },
  { id: 96, name: "Tonkinese" },
  { id: 97, name: "Toybob" },
  { id: 98, name: "Toyger" },
  { id: 99, name: "Turkish Angora" },
  { id: 100, name: "Turkish Van" },
  { id: 101, name: "Turkish Vankedisi" },
  { id: 102, name: "Ukrainian Levkoy" },
  { id: 103, name: "York Chocolate" }
];
